export default __webpack_public_path__ + "static/media/puzzlePieceBackground.a574edbb.png";